import { InjectionToken } from '@angular/core';

export const WindowToken = new InjectionToken('window-token');
